module.exports = __webpack_public_path__ + "img/1.57574c01.png";